exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-div[data-v-fb28ba5e]{position:relative;overflow:hidden;width:57px}.upload-div .upload-input[data-v-fb28ba5e]{cursor:pointer;position:absolute;z-index:1000;font-size:100px;opacity:0;right:0}\n", ""]);

// exports
